import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_trainer",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-6 mb-2" }
const _hoisted_9 = { class: "col-md-6 mb-2" }
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_12 = { class: "form-group mr-b-0em" }
const _hoisted_13 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mr-b-0em" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mr-b-0em" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mr-b-0em" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mr-b-0em" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mr-b-0em" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mr-b-0em" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group mr-b-0em" }
const _hoisted_29 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_30 = { class: "form-group mr-b-0em" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "form-group mr-b-0em" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "form-group mr-b-0em" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "form-group mr-b-0em" }
const _hoisted_37 = { class: "col-12 text-right" }
const _hoisted_38 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_radioInput = _resolveComponent("radioInput")!
  const _component_input_image = _resolveComponent("input-image")!
  const _component_capture_photo = _resolveComponent("capture-photo")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_phone_number = _resolveComponent("phone-number")!
  const _component_MultipSelect = _resolveComponent("MultipSelect")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_price_input = _resolveComponent("price-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestTrainer)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('views.clients.trainer.add')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_add_trainer', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestTrainer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_radioInput, {
                      modelValue: _ctx.isCaputre,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCaputre) = $event)),
                      valueAttr: 1,
                      label: _ctx.i18n.t('button.upload_image'),
                      name: `isCaputre`,
                      id: "club-logo-1"
                    }, null, 8, ["modelValue", "label"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_radioInput, {
                      modelValue: _ctx.isCaputre,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCaputre) = $event)),
                      valueAttr: 0,
                      label: _ctx.i18n.t('button.take_photo'),
                      name: `isCaputre`,
                      id: "club-logo-0"
                    }, null, 8, ["modelValue", "label"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.isCaputre)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_input_image, {
                            modelValue: _ctx.requestTrainer.path_image,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestTrainer.path_image) = $event)),
                            label: _ctx.i18n.t('tables.club.path_image'),
                            pathImage: _ctx.image,
                            v: _ctx.v$.path_image,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "pathImage", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isCaputre)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_capture_photo, {
                          modelValue: _ctx.requestTrainer.path_image,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestTrainer.path_image) = $event)),
                          v: _ctx.v$.path_image,
                          pathImage: _ctx.image
                        }, null, 8, ["modelValue", "v", "pathImage"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_SingleSelect, {
                        TextLabel: _ctx.i18n.t('tables.trainer.personType'),
                        trackby: `id`,
                        label: `name`,
                        valueProp: `id`,
                        modelValue: _ctx.requestTrainer.personType,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestTrainer.personType) = $event)),
                        placeholder: _ctx.i18n.t('tables.trainer.personType'),
                        arrayOptions: _ctx.personTypesList,
                        v: _ctx.v$.personType,
                        refs: "personType"
                      }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_SingleSelect, {
                        TextLabel: _ctx.i18n.t('tables.trainer.gender'),
                        trackby: `id`,
                        label: `name`,
                        valueProp: `id`,
                        modelValue: _ctx.requestTrainer.gender,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestTrainer.gender) = $event)),
                        placeholder: _ctx.i18n.t('tables.trainer.gender'),
                        arrayOptions: _ctx.filteredGenders,
                        refs: "gender",
                        v: _ctx.v$.gender
                      }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestTrainer.name,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestTrainer.name) = $event)),
                        label: _ctx.i18n.t('tables.trainer.name'),
                        v: _ctx.v$.name,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestTrainer.email,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestTrainer.email) = $event)),
                        label: _ctx.i18n.t('tables.trainer.email'),
                        v: _ctx.v$.email,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_phone_number, {
                        modelValue: _ctx.requestTrainer.tele,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestTrainer.tele) = $event)),
                        label: _ctx.i18n.t('tables.trainer.tele'),
                        v: _ctx.v$.tele,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestTrainer.cin,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestTrainer.cin) = $event)),
                        label: _ctx.i18n.t('tables.trainer.cin'),
                        v: _ctx.v$.cin,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestTrainer.adresse,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestTrainer.adresse) = $event)),
                        label: _ctx.i18n.t('tables.trainer.adresse'),
                        v: _ctx.v$.adresse,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  (_ctx.requestTrainer.personType == 'coach')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_MultipSelect, {
                            TextLabel: _ctx.i18n.t('tables.trainer.specialization'),
                            trackby: `name`,
                            label: `name`,
                            valueProp: `name`,
                            modelValue: _ctx.requestTrainer.specialization,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestTrainer.specialization) = $event)),
                            placeholder: _ctx.i18n.t('tables.trainer.specialization'),
                            arrayOptions: _ctx.specializationsList,
                            refs: "specialization",
                            v: _ctx.v$.specialization
                          }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_date_field, {
                        modelValue: _ctx.requestTrainer.start_date,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.requestTrainer.start_date) = $event)),
                        label: _ctx.i18n.t('tables.trainer.start_date'),
                        v: _ctx.v$.start_date,
                        disabled: false,
                        fixedDays: 1,
                        isFixedDays: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_SingleSelect, {
                        TextLabel: _ctx.i18n.t('tables.trainer.contractType'),
                        trackby: `name`,
                        label: `name`,
                        valueProp: `name`,
                        modelValue: _ctx.requestTrainer.contractType,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.requestTrainer.contractType) = $event)),
                        placeholder: _ctx.i18n.t('tables.trainer.contractType'),
                        arrayOptions: _ctx.contractsTypesList,
                        refs: "contractType",
                        v: _ctx.v$.gender
                      }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_price_input, {
                        modelValue: _ctx.requestTrainer.salary,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.requestTrainer.salary) = $event)),
                        label: _ctx.i18n.t('tables.trainer.salary'),
                        v: _ctx.v$.salary,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.emptyState())),
                      class: "btn btn-cancel"
                    }, _toDisplayString(_ctx.i18n.t('button.clean')), 1)
                  ])
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}